// removed by extract-text-webpack-plugin
module.exports = {"text-overflow":"text-overflow___1VUuU","footer":"footer___1rpzX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Footer.less
// module id = 733
// module chunks = 3